import React, { useEffect, useState } from "react";
import WebFont from "webfontloader";
import Signup_Landing from "./Signup_Landing";
import AutoScrollCarousel from "./AutoScrollCarousel";
import { Link } from "react-router-dom";

const Landing = () => {
  useEffect(() => {
    WebFont.load({
      google: {
        families: ["Playfair Display", "Open Sans"],
      },
    });
  }, []);

  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 768);

  const step1Banner =
    process.env.PUBLIC_URL + "/assets/landing/webImages/step1/step1Banner.png";
  const step1Banner2 =
    process.env.PUBLIC_URL + "/assets/landing/webImages/step1/step1Banner2.png";
  const step1MobileBanner =
    process.env.PUBLIC_URL + "/assets/landing/mobileImages/step1/bg-img.png";
  const step1Mobile =
    process.env.PUBLIC_URL + "/assets/landing/mobileImages/step1/step1.png";

  const step2 =
    process.env.PUBLIC_URL + "/assets/landing/webImages/step2/step2Current.png";
  const step2Mobile =
    process.env.PUBLIC_URL + "/assets/landing/mobileImages/step2/step2.png";

  const step3Mobile =
    process.env.PUBLIC_URL + "/assets/landing/mobileImages/step3/step3.png";
  const step3LeftPic =
    process.env.PUBLIC_URL + "/assets/landing/webImages/step3/picture/left.png";

  const step3LeftVideo =
    process.env.PUBLIC_URL + "/assets/landing/videos/askFriend.gif";

  const step3RightPic =
    process.env.PUBLIC_URL +
    "/assets/landing/webImages/step3/picture/right.png";
  const step3Vector =
    process.env.PUBLIC_URL +
    "/assets/landing/webImages/step3/picture/vector.png";

  const inviteFriend =
    process.env.PUBLIC_URL + "/assets/landing/videos/inviteFriend.gif";
  const step4LeftGif =
    process.env.PUBLIC_URL + "/assets/landing/videos/saveToList.gif";
  const step4LeftPicMobile =
    process.env.PUBLIC_URL + "/assets/landing/mobileImages/step4/leftPic.png";
  const step4LeftPicIcon =
    process.env.PUBLIC_URL + "/assets/landing/webImages/step4/leftPic/icon.png";
  const step4rightPic =
    process.env.PUBLIC_URL +
    "/assets/landing/webImages/step4/rightPic/mainPic.png";
  const step4rightGif =
    process.env.PUBLIC_URL + "/assets/landing/videos/viewShoppingList.gif";
  const step4rightPicMobile =
    process.env.PUBLIC_URL + "/assets/landing/mobileImages/step4/rightPic.png";
  const step4rightPicIcon =
    process.env.PUBLIC_URL +
    "/assets/landing/webImages/step4/rightPic/icon.png";
  const step4Mobile =
    process.env.PUBLIC_URL + "/assets/landing/mobileImages/step4/step4.png";

  const step5 =
    process.env.PUBLIC_URL + "/assets/landing/webImages/step5/step5.png";
  const step5Mobile =
    process.env.PUBLIC_URL + "/assets/landing/mobileImages/step5/step5.png";

  const step5PicMobile =
    process.env.PUBLIC_URL + "/assets/landing/mobileImages/step5/mainPic.png";
  const step5Pic =
    process.env.PUBLIC_URL + "/assets/landing/webImages/step5/mainPic.png";

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 768);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  // Section container style with snap scroll
  const sectionContainerStyle = {
    height: "100vh",
    width: "100vw",
    overflowY: "auto",
    scrollSnapType: "y mandatory",
    scrollBehavior: "smooth",
    position: "absolute",
    left: 0,
    top: 0,
  };

  // Section style for each content block
  const sectionStyle = {
    height: "100vh",
    width: "100%",
    scrollSnapAlign: "center",
    position: "relative",
    overflow: "hidden",
  };

  return (
    <div style={sectionContainerStyle}>
      {/* Personalised Product Recommendation */}
      {isSmallScreen ? (
        <>
          {/* <div>
            <img src={step1Mobile} alt="" />
          </div> */}
          <div
            className="pb-5"
            style={{
              ...sectionStyle,
              backgroundImage: `url(${step1MobileBanner})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
          >
            <div className="text-center d-flex flex-column align-items-center justify-content-center h-100">
              <div
                style={{
                  fontSize: "2rem",
                  lineHeight: "2.5rem",
                  fontFamily: "Playfair Display",
                  fontWeight: 500,
                  color: "white",
                }}
              >
                Personalised{" "}
                <div
                  style={{
                    position: "relative",
                  }}
                  className="d-inline-flex justify-content-center"
                >
                  <svg
                    style={{
                      position: "absolute",
                      height: "4.5rem",
                      top: "-1rem",
                    }}
                    width="172"
                    viewBox="0 0 172 72"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g opacity="0.5">
                      <path
                        d="M162.915 35.9814C162.915 39.0566 160.894 42.0808 157.013 44.9122C153.144 47.7358 147.512 50.2995 140.507 52.4611C126.505 56.7825 107.13 59.4629 85.7074 59.4629C64.2848 59.4629 44.91 56.7825 30.9074 52.4611C23.9031 50.2995 18.2712 47.7358 14.4013 44.9122C10.5208 42.0808 8.5 39.0566 8.5 35.9814C8.5 32.9062 10.5208 29.8821 14.4013 27.0507C18.2712 24.2271 23.9031 21.6634 30.9074 19.5018C44.91 15.1804 64.2848 12.5 85.7074 12.5C107.13 12.5 126.505 15.1804 140.507 19.5018C147.512 21.6634 153.144 24.2271 157.013 27.0507C160.894 29.8821 162.915 32.9062 162.915 35.9814Z"
                        stroke="#E87C00"
                      />
                      <path
                        d="M171.469 53.8056C171.393 55.0017 170.792 56.1062 169.633 57.1065C168.47 58.1091 166.771 58.9844 164.565 59.7165C160.156 61.1802 153.821 62.0398 146.004 62.2663C130.378 62.7192 108.938 60.6404 85.3915 55.9148C61.8451 51.1892 40.6816 44.7175 25.5029 38.0823C17.9096 34.763 11.8406 31.4141 7.7233 28.239C5.6643 26.6512 4.11618 25.124 3.10777 23.6857C2.10174 22.2508 1.65345 20.9358 1.7289 19.7396C1.80435 18.5435 2.40524 17.439 3.56487 16.4387C4.72725 15.4361 6.4269 14.5607 8.63223 13.8287C13.0421 12.365 19.3766 11.5054 27.1935 11.2789C42.8193 10.826 64.2599 12.9047 87.8062 17.6304C111.353 22.356 132.516 28.8277 147.695 35.4629C155.288 38.7822 161.357 42.131 165.474 45.3062C167.533 46.894 169.082 48.4211 170.09 49.8595C171.096 51.2944 171.544 52.6094 171.469 53.8056Z"
                        stroke="#E87C00"
                      />
                    </g>
                  </svg>
                  Product
                </div>{" "}
                Recommendation
              </div>
              <p
                className="text-center "
                style={{
                  fontFamily: "Open Sans",
                  fontWeight: 400,
                  fontSize: "1rem",
                  margin: "0rem 2rem",
                  color: "white",
                }}
              >
                Smart suggestions that match your taste, making shopping easier
                and more personal.
              </p>
            </div>
          </div>
        </>
      ) : (
        <div style={{ ...sectionStyle, paddingTop: "7rem" }}>
          <div className="container d-flex flex-column justify-content-center ps-4 pe-1 align-items-center">
            <div
              className="text-center d-flex flex-column align-items-center"
              style={{
                margin: "0rem 15rem",
                position: "relative",
              }}
            >
              <svg
                className="mx-auto start-0 end-0"
                style={{
                  position: "absolute",
                  height: "13.5rem",
                  top: "-3.5rem",
                }}
                width="447"
                height="285"
                viewBox="0 0 447 285"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g opacity="0.5">
                  <path
                    d="M402.185 80.4111C404.395 86.6642 401.765 94.4316 394.802 103.214C387.859 111.974 376.703 121.615 362.17 131.545C333.109 151.401 290.641 172.347 241.654 189.666C192.667 206.984 146.47 217.383 111.387 220.204C93.8419 221.614 79.1056 221.127 68.1994 218.678C57.2638 216.223 50.336 211.834 48.1253 205.581C45.9147 199.328 48.5451 191.561 55.5076 182.778C62.4514 174.019 73.6071 164.378 88.1405 154.448C117.201 134.592 159.669 113.645 208.656 96.3267C257.643 79.0085 303.84 68.6094 338.923 65.7888C356.468 64.3781 371.205 64.8655 382.111 67.3143C393.046 69.7697 399.974 74.1579 402.185 80.4111Z"
                    stroke="#E87C00"
                  />
                  <path
                    d="M429.761 107.044C430.459 109.6 429.806 112.382 427.795 115.369C425.785 118.356 422.446 121.5 417.881 124.746C408.752 131.237 394.81 138.069 377.085 144.838C341.641 158.372 291.163 171.612 234.055 181.344C176.946 191.076 124.047 195.452 84.6915 194.665C65.0095 194.272 48.7416 192.587 37.0368 189.647C31.1828 188.177 26.5002 186.399 23.1089 184.333C19.718 182.266 17.6706 179.944 16.9727 177.389C16.2747 174.834 16.9278 172.052 18.9383 169.064C20.949 166.077 24.2873 162.933 28.853 159.687C37.9819 153.197 51.9232 146.364 69.6489 139.596C105.093 126.062 155.571 112.821 212.679 103.089C269.787 93.3574 322.687 88.9811 362.042 89.7681C381.724 90.1616 397.992 91.8463 409.697 94.7863C415.551 96.2567 420.234 98.0339 423.625 100.101C427.016 102.167 429.063 104.489 429.761 107.044Z"
                    stroke="#E87C00"
                  />
                </g>
              </svg>
              <h1
                style={{
                  fontSize: "2.75rem",
                  fontFamily: "Playfair Display",
                  fontWeight: 500,
                }}
              >
                Personalised Product Recommendation
              </h1>
              <p
                className="text-center "
                style={{
                  fontFamily: "Open Sans",
                  fontWeight: 400,
                  fontSize: "1.3rem",
                  margin: "0rem 7rem",
                  color: "#4D4D4D",
                }}
              >
                Smart suggestions that match your taste, making shopping easier
                and more personal.
              </p>
            </div>
          </div>
          <div
            style={{ marginTop: "3.5rem" }}
            className="d-flex flex-column gap-2"
          >
            <AutoScrollCarousel direction={"left"} />
            {/* <AutoScrollCarousel direction={"right"} /> */}
            {/* <img src={step1Banner} style={{ height: "14rem" }} alt="" />
            <img src={step1Banner2} style={{ height: "14rem" }} alt="" /> */}
          </div>
        </div>
      )}

      {/* Get Style Inspiration for Upcoming Event */}
      <div
        style={{ ...sectionStyle, backgroundColor: "#FFF8F0" }}
        className="d-flex align-items-center justify-content-center"
      >
        {/* Carousel will added here */}
        {isSmallScreen ? (
          <img
            src={step2Mobile}
            alt=""
            className="w-100 vh-100"
            style={{ objectFit: "contain" }}
          />
        ) : (
          <div className="container mt-5" style={{ position: "relative" }}>
            <img
              src={step2}
              alt=""
              className="w-100"
              style={{
                width: "100%",
                height: "580px",
                objectFit: "contain",
                objectPosition: "center",
              }}
            />
            <div
              style={{
                position: "absolute",
                bottom: "0.5rem",
                marginInline: "auto",
                paddingInline: "26rem",
                textAlign: "center",
              }}
            >
              <svg
                className="mx-auto start-0 end-0"
                style={{
                  position: "absolute",
                  height: "9.5rem",
                  top: "-2.5rem",
                }}
                width="274"
                height="176"
                viewBox="0 0 274 176"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g opacity="0.5">
                  <path
                    d="M27.7102 50.3142C26.3905 54.0473 27.9466 58.7342 32.2036 64.1041C36.4418 69.4504 43.2606 75.3459 52.1596 81.4263C69.9515 93.5828 95.9614 106.413 125.971 117.022C155.981 127.631 184.275 134 205.754 135.726C216.498 136.59 225.507 136.29 232.163 134.796C238.849 133.294 243.006 130.627 244.325 126.894C245.645 123.161 244.089 118.474 239.832 113.104C235.594 107.758 228.775 101.862 219.876 95.7817C202.084 83.6252 176.074 70.7952 146.064 60.1858C116.055 49.5765 87.7602 43.2084 66.2813 41.4815C55.538 40.6178 46.5289 40.9177 39.8722 42.4124C33.1861 43.9136 29.03 46.581 27.7102 50.3142Z"
                    stroke="#E87C00"
                  />
                  <path
                    d="M10.8184 66.6039C10.4096 68.1003 10.7847 69.7535 12.0009 71.5604C13.2173 73.3677 15.245 75.2806 18.0346 77.264C23.6114 81.2289 32.1389 85.4098 42.9961 89.5555C64.7027 97.8438 95.6246 105.955 130.614 111.918C165.604 117.881 198.009 120.561 222.112 120.079C234.167 119.838 244.119 118.806 251.269 117.01C254.846 116.112 257.692 115.029 259.743 113.779C261.795 112.529 262.999 111.145 263.408 109.648C263.817 108.152 263.442 106.499 262.225 104.692C261.009 102.885 258.981 100.972 256.192 98.9884C250.615 95.0235 242.087 90.8426 231.23 86.6969C209.524 78.4085 178.602 70.297 143.612 64.3343C108.622 58.3717 76.2169 55.6913 52.1146 56.1733C40.0592 56.4144 30.1078 57.4462 22.9574 59.2423C19.3806 60.1407 16.5346 61.2231 14.483 62.4735C12.4318 63.7236 11.2271 65.1076 10.8184 66.6039Z"
                    stroke="#E87C00"
                  />
                </g>
              </svg>

              <h1
                style={{
                  fontSize: "2.5rem",
                  fontFamily: "Playfair Display",
                  fontWeight: 500,
                }}
              >
                <div style={{ color: "#E87C00" }}>
                  Get Style Inspiration for
                </div>{" "}
                <div>Upcoming Event</div>
              </h1>
              <svg
                className="mt-4"
                width="116"
                height="12"
                viewBox="0 0 116 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect width="44" height="12" rx="5" fill="#D47100" />
                <rect
                  opacity="0.15"
                  x="51"
                  width="17"
                  height="12"
                  rx="5"
                  fill="#4D4D4D"
                />
                <rect
                  opacity="0.15"
                  x="75"
                  width="17"
                  height="12"
                  rx="5"
                  fill="#4D4D4D"
                />
                <rect
                  opacity="0.15"
                  x="99"
                  width="17"
                  height="12"
                  rx="5"
                  fill="#4D4D4D"
                />
              </svg>
            </div>
          </div>
        )}
      </div>

      {/* Ask Your Friend for Quick Feedback */}
      {isSmallScreen ? (
        <>
          {/* <div>
            <img src={step3Mobile} alt="" />
          </div> */}
          <div
            style={{
              ...sectionStyle,
              backgroundColor: "#F0FFFA",
              padding: "10rem 1rem",
            }}
            className="d-flex flex-column align-items-center gap-3"
          >
            <div className="d-flex flex-column gap-3 text-center px-3">
              <div
                style={{
                  color: "#016B6C",
                  fontSize: "2rem",
                  lineHeight: "2.5rem",
                  fontFamily: "Playfair Display",
                  fontWeight: 600,
                }}
              >
                Ask Your{" "}
                <div
                  className="d-inline-flex justify-content-center"
                  style={{ position: "relative" }}
                >
                  <svg
                    className="mx-auto"
                    style={{
                      position: "absolute",
                      height: "6rem",
                      top: "-1.5rem",
                    }}
                    width="331"
                    height="210"
                    viewBox="0 0 331 210"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g opacity="0.5">
                      <path
                        d="M300.95 79.4658C302.249 86.0418 299.833 93.0935 294.213 100.247C288.594 107.399 279.811 114.597 268.507 121.428C245.902 135.088 213.31 147.22 176.09 154.567C138.87 161.914 104.112 163.076 78.0127 159.031C64.9607 157.007 54.1017 153.686 46.1866 149.205C38.2696 144.724 33.3559 139.119 32.0578 132.543C30.7598 125.967 33.1752 118.915 38.7955 111.762C44.4145 104.61 53.1969 97.4114 64.5012 90.5804C87.1061 76.9207 119.698 64.7884 156.918 57.4415C194.138 50.0946 228.896 48.9325 254.996 52.9784C268.048 55.0016 278.907 58.323 286.822 62.8034C294.739 67.2848 299.652 72.8897 300.95 79.4658Z"
                        stroke="#016B6C"
                      />
                      <path
                        d="M319.867 110.665C320.627 116.001 317.228 121.058 310.1 125.603C302.996 130.132 292.311 134.07 278.818 137.215C251.838 143.504 213.744 146.601 170.933 145.005C128.122 143.41 88.7345 137.424 59.6678 129.046C45.1306 124.856 33.2042 120.075 24.7279 114.965C16.2231 109.837 11.3408 104.472 10.5813 99.1355C9.82172 93.7996 13.2204 88.7425 20.3484 84.1976C27.4526 79.668 38.1381 75.7306 51.6311 72.5854C78.6101 66.2965 116.704 63.199 159.516 64.7948C202.327 66.3907 241.714 72.3765 270.781 80.7545C285.318 84.9447 297.244 89.725 305.721 94.8354C314.226 99.9629 319.108 105.329 319.867 110.665Z"
                        stroke="#016B6C"
                      />
                    </g>
                  </svg>
                  Friend
                </div>{" "}
                for Quick Feedback
              </div>
              <p
                className="px-4"
                style={{
                  fontFamily: "Open Sans",
                  fontWeight: 400,
                  fontSize: "1rem",
                  color: "#4D4D4D",
                }}
              >
                Not sure about your choice? Let your friends weigh in before you
                decide.
              </p>
            </div>
            <div style={{ height: "20rem", width: "100%" }}>
              <div
                className="h-100"
                style={{
                  position: "relative",
                }}
              >
                <img
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    zIndex: 2,
                    height: "16rem",
                    width: "68%",
                    objectFit: "cover",
                    border: "3px solid #016B6C",
                    borderRadius: "40px",
                    boxSizing: "border-box",
                  }}
                  src={step3LeftVideo}
                  alt=""
                />
                <img
                  style={{
                    position: "absolute",
                    bottom: "3rem",
                    right: "3.7rem",
                    zIndex: 3,
                    height: "8rem",
                  }}
                  src={step3Vector}
                  alt=""
                />
                <img
                  style={{
                    position: "absolute",
                    bottom: 0,
                    right: 0,
                    zIndex: 1,
                    height: "9rem",
                  }}
                  src={step3RightPic}
                  alt=""
                />
              </div>
            </div>
          </div>
        </>
      ) : (
        <div
          style={{
            ...sectionStyle,
            backgroundColor: "#F0FFFA",
            padding: "5rem 0rem",
          }}
          className="d-flex justify-content-center align-items-center"
        >
          <div className="container d-flex align-items-center w-100 ps-4">
            <div
              style={{ width: "55%" }}
              className="d-flex flex-column pe-5 gap-1"
            >
              <div
                style={{
                  color: "#016B6C",
                  fontSize: "3.5rem",
                  lineHeight: "4.5rem",
                  fontFamily: "Playfair Display",
                  fontWeight: 500,
                }}
              >
                Ask your{" "}
                <div
                  style={{ position: "relative", display: "inline-flex" }}
                  className="justify-content-center"
                >
                  <svg
                    style={{
                      position: "absolute",
                      height: "12rem",
                      top: "-3.5rem",
                    }}
                    width="331"
                    height="210"
                    viewBox="0 0 331 210"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g opacity="0.5">
                      <path
                        d="M300.95 79.4658C302.249 86.0418 299.833 93.0935 294.213 100.247C288.594 107.399 279.811 114.597 268.507 121.428C245.902 135.088 213.31 147.22 176.09 154.567C138.87 161.914 104.112 163.076 78.0127 159.031C64.9607 157.007 54.1017 153.686 46.1866 149.205C38.2696 144.724 33.3559 139.119 32.0578 132.543C30.7598 125.967 33.1752 118.915 38.7955 111.762C44.4145 104.61 53.1969 97.4114 64.5012 90.5804C87.1061 76.9207 119.698 64.7884 156.918 57.4415C194.138 50.0946 228.896 48.9325 254.996 52.9784C268.048 55.0016 278.907 58.323 286.822 62.8034C294.739 67.2848 299.652 72.8897 300.95 79.4658Z"
                        stroke="#016B6C"
                      />
                      <path
                        d="M319.867 110.665C320.627 116.001 317.228 121.058 310.1 125.603C302.996 130.132 292.311 134.07 278.818 137.215C251.838 143.504 213.744 146.601 170.933 145.005C128.122 143.41 88.7345 137.424 59.6678 129.046C45.1306 124.856 33.2042 120.075 24.7279 114.965C16.2231 109.837 11.3408 104.472 10.5813 99.1355C9.82172 93.7996 13.2204 88.7425 20.3484 84.1976C27.4526 79.668 38.1381 75.7306 51.6311 72.5854C78.6101 66.2965 116.704 63.199 159.516 64.7948C202.327 66.3907 241.714 72.3765 270.781 80.7545C285.318 84.9447 297.244 89.725 305.721 94.8354C314.226 99.9629 319.108 105.329 319.867 110.665Z"
                        stroke="#016B6C"
                      />
                    </g>
                  </svg>
                  <span>Friends</span>
                </div>{" "}
                for Quick Feedback
              </div>
              <p
                className=" me-0 me-lg-4"
                style={{
                  fontFamily: "Open Sans",
                  fontWeight: 400,
                  fontSize: "1.6rem",
                  color: "#4D4D4D",
                }}
              >
                Not sure about your choice? Let your friends weigh in before you
                decide.
              </p>
            </div>
            <div style={{ height: "25rem", width: "50%" }}>
              <div
                className="h-100"
                style={{
                  position: "relative",
                }}
              >
                <img
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    zIndex: 2,
                    height: "22rem",
                    width: "68%",
                    objectFit: "cover",
                    // marginLeft: "-2rem",
                    border: "3px solid #016B6C",
                    borderRadius: "40px",
                    boxSizing: "border-box",
                  }}
                  src={step3LeftVideo}
                  alt=""
                />

                <img
                  style={{
                    position: "absolute",
                    bottom: "4.5rem",
                    right: "7.5rem",
                    zIndex: 3,
                    height: "9rem",
                  }}
                  src={step3Vector}
                  alt=""
                />
                <img
                  style={{
                    position: "absolute",
                    bottom: 0,
                    right: "2rem",
                    zIndex: 1,
                    height: "13rem",
                  }}
                  src={step3RightPic}
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Save Products to Shopping List */}
      {isSmallScreen ? (
        <>
          {/* <div>
            <img src={step4Mobile} alt="" />
          </div> */}
          <div
            style={{
              ...sectionStyle,
              backgroundColor: "#FFF1F1",
              padding: "5rem 1rem",
            }}
            className="d-flex flex-column align-items-center gap-1"
          >
            <div
              className="d-flex flex-column text-center gap-1"
              // style={{ width: "45%" }}
            >
              <div
                style={{
                  color: "#E72627",
                  fontSize: "2rem",
                  lineHeight: "2.5rem",
                  fontFamily: "Playfair Display",
                  fontWeight: 600,
                }}
              >
                Save{" "}
                <div
                  className="d-inline-flex justify-content-center"
                  style={{ position: "relative" }}
                >
                  <svg
                    className="mx-auto"
                    style={{
                      position: "absolute",
                      height: "11rem",
                      top: "-4rem",
                    }}
                    width="165"
                    height="79"
                    viewBox="0 0 165 79"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g opacity="0.5">
                      <path
                        d="M156.089 40.1244C156.089 43.4592 154.154 46.7075 150.492 49.7292C146.834 52.7483 141.511 55.4894 134.888 57.8011C121.648 62.4228 103.324 65.2906 83.0611 65.2906C62.7977 65.2906 44.474 62.4228 31.2338 57.8011C24.6114 55.4894 19.2878 52.7483 15.6296 49.7292C11.9682 46.7075 10.0332 43.4592 10.0332 40.1244C10.0332 36.7897 11.9682 33.5414 15.6296 30.5196C19.2878 27.5006 24.6114 24.7594 31.2338 22.4478C44.474 17.826 62.7977 14.9583 83.0611 14.9583C103.324 14.9583 121.648 17.826 134.888 22.4478C141.511 24.7594 146.834 27.5006 150.492 30.5196C154.154 33.5414 156.089 36.7897 156.089 40.1244Z"
                        stroke="#E72627"
                      />
                      <path
                        d="M162.785 57.6658C162.639 60.2868 160.441 62.4567 156.242 64.0331C152.075 65.5976 146.087 66.517 138.694 66.7594C123.916 67.2438 103.635 65.0201 81.3596 59.9635C59.0842 54.9069 39.0653 47.9824 24.7099 40.8845C17.5286 37.3337 11.7916 33.7527 7.90097 30.3591C3.98096 26.9398 2.07643 23.8384 2.22259 21.2174C2.36875 18.5964 4.56723 16.4265 8.76582 14.8502C12.933 13.2856 18.9209 12.3662 26.3137 12.1239C41.0919 11.6394 61.373 13.8632 83.6484 18.9198C105.924 23.9764 125.943 30.9009 140.298 37.9988C147.479 41.5495 153.216 45.1305 157.107 48.5242C161.027 51.9434 162.932 55.0448 162.785 57.6658Z"
                        stroke="#E72627"
                      />
                    </g>
                  </svg>
                  Products
                </div>{" "}
                to Shopping List
              </div>
              <p
                className="px-5"
                style={{
                  fontFamily: "Open Sans",
                  fontWeight: 400,
                  fontSize: "1rem",
                  color: "#4D4D4D",
                }}
              >
                Create a personalized list so you never lose sight of what you
                love.
              </p>
            </div>
            <div style={{ height: "31rem", width: "100%" }}>
              <div
                className="h-100"
                style={{
                  position: "relative",
                }}
              >
                <div>
                  <img
                    src={step4LeftGif}
                    alt=""
                    style={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      zIndex: 2,
                      height: "16rem",
                      width: "18rem",
                      objectPosition: "bottom",
                      padding: "8px", // Gap between image and border
                      border: "3px solid #E72627",
                      borderRadius: "2rem 8rem 2rem 2rem", // Rounded corners
                      boxSizing: "border-box",
                      objectFit: "cover",
                    }}
                  />
                  <img
                    src={step4LeftPicIcon}
                    alt=""
                    style={{
                      height: "3.5rem",
                      position: "absolute",
                      left: "1rem",
                      top: "14rem",
                      objectFit: "cover",
                    }}
                  />
                </div>
                <div>
                  <img
                    src={step4rightGif}
                    alt=""
                    style={{
                      position: "absolute",
                      bottom: 0,
                      right: 0,
                      zIndex: 2,
                      height: "13rem",
                      width: "16rem",
                      padding: "8px", // Gap between image and border
                      border: "3px solid #E72627",
                      borderRadius: "2rem 2rem 2rem 8rem", // Rounded corners
                      boxSizing: "border-box",
                      objectFit: "cover",
                    }}
                  />

                  <img
                    src={step4rightPicIcon}
                    alt=""
                    style={{
                      height: "3.5rem",
                      position: "absolute",
                      right: "-0.5rem",
                      bottom: "-1rem",
                      objectFit: "cover",
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </>
      ) : (
        <div
          style={{
            ...sectionStyle,
            backgroundColor: "#FFF1F1",
            padding: "2rem 0rem",
          }}
          className="d-flex justify-content-center align-items-center"
        >
          <div
            className="container d-flex align-items-center w-100 ps-4"
            style={{ gap: "6rem" }}
          >
            <div style={{ height: "25rem", width: "51%" }}>
              <div
                className="h-100"
                style={{
                  position: "relative",
                }}
              >
                <div>
                  <div
                    style={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      zIndex: 2,
                      height: "25rem",
                      padding: "5px", // Gap between image and border
                      border: "3px solid #E72627",
                      borderRadius: "2rem 2rem 2rem 6rem", // Rounded corners
                      boxSizing: "border-box",
                    }}
                  >
                    <img
                      src={step4LeftGif}
                      alt=""
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        border: "3px ",
                        borderRadius: "2rem 2rem 2rem 6rem", // Rounded corners
                        boxSizing: "border-box",
                      }}
                    />
                  </div>
                  <img
                    src={step4LeftPicIcon}
                    alt=""
                    style={{
                      height: "3.5rem",
                      position: "absolute",
                      left: "13.5rem",
                      top: "-1.5rem",
                      objectFit: "cover",
                    }}
                  />
                </div>
                <div>
                  <img
                    src={step4rightGif}
                    alt=""
                    style={{
                      position: "absolute",
                      bottom: 0,
                      right: 0,
                      zIndex: 2,
                      width: "19rem",
                      height: "19rem",
                      padding: "5px", // Gap between image and border
                      border: "3px solid #E72627",
                      borderRadius: "2rem 6rem 2rem 2rem", // Rounded corners
                      boxSizing: "border-box",
                      objectFit: "cover",
                    }}
                  />
                  <img
                    src={step4rightPicIcon}
                    alt=""
                    style={{
                      height: "3.5rem",
                      position: "absolute",
                      right: "-0.5rem",
                      bottom: "-1rem",
                      objectFit: "cover",
                    }}
                  />
                </div>
              </div>
            </div>

            <div className="d-flex flex-column" style={{ width: "40%" }}>
              <div
                style={{
                  color: "#E72627",
                  fontSize: "3.5rem",
                  lineHeight: "4.5rem",
                  fontFamily: "Playfair Display",
                  fontWeight: 500,
                }}
              >
                Save{" "}
                <div
                  style={{ position: "relative" }}
                  className="d-inline-flex justify-content-center"
                >
                  <svg
                    className="mx-auto"
                    style={{
                      position: "absolute",
                      height: "11rem",
                      top: "-3rem",
                    }}
                    width="331"
                    height="210"
                    viewBox="0 0 331 210"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g opacity="0.5">
                      <path
                        d="M300.95 79.4658C302.249 86.0418 299.833 93.0935 294.213 100.247C288.594 107.399 279.811 114.597 268.507 121.428C245.902 135.088 213.31 147.22 176.09 154.567C138.87 161.914 104.112 163.076 78.0127 159.031C64.9607 157.007 54.1017 153.686 46.1866 149.205C38.2696 144.724 33.3559 139.119 32.0578 132.543C30.7598 125.967 33.1752 118.915 38.7955 111.762C44.4145 104.61 53.1969 97.4114 64.5012 90.5804C87.1061 76.9207 119.698 64.7884 156.918 57.4415C194.138 50.0946 228.896 48.9325 254.996 52.9784C268.048 55.0016 278.907 58.323 286.822 62.8034C294.739 67.2848 299.652 72.8897 300.95 79.4658Z"
                        stroke="#E72627"
                      />
                      <path
                        d="M319.867 110.665C320.627 116.001 317.228 121.058 310.1 125.603C302.996 130.132 292.311 134.07 278.818 137.215C251.838 143.504 213.744 146.601 170.933 145.005C128.122 143.41 88.7345 137.424 59.6678 129.046C45.1306 124.856 33.2042 120.075 24.7279 114.965C16.2231 109.837 11.3408 104.472 10.5813 99.1355C9.82172 93.7996 13.2204 88.7425 20.3484 84.1976C27.4526 79.668 38.1381 75.7306 51.6311 72.5854C78.6101 66.2965 116.704 63.199 159.516 64.7948C202.327 66.3907 241.714 72.3765 270.781 80.7545C285.318 84.9447 297.244 89.725 305.721 94.8354C314.226 99.9629 319.108 105.329 319.867 110.665Z"
                        stroke="#E72627"
                      />
                    </g>
                  </svg>
                  Products
                </div>{" "}
                to Shopping List
              </div>
              <p
                className=" mt-4"
                style={{
                  fontFamily: "Open Sans",
                  fontWeight: 400,
                  fontSize: "1.75rem",
                  color: "#4D4D4D",
                }}
              >
                Create a personalized list so you never lose sight of what you
                love.
              </p>
            </div>
          </div>
        </div>
      )}

      {/* Invite your Friends to view Your Shopping List */}
      {isSmallScreen ? (
        <>
          {/* <div>
            <img src={step5Mobile} alt="" />
          </div> */}
          <div
            style={{
              ...sectionStyle,
              backgroundColor: "#FFF8F0",
            }}
            className={`d-flex flex-column align-items-center `}
          >
            <div
              className="d-flex flex-column justify-content-center gap-4 text-center"
              style={{
                height: "50%",
                padding: "0rem 2.6rem",
              }}
            >
              <div
                style={{
                  color: "black",
                  fontSize: "2rem",
                  lineHeight: "3rem",
                  fontFamily: "Playfair Display",
                  fontWeight: 600,
                }}
              >
                Invite your{" "}
                <div
                  className="d-inline-flex justify-content-center"
                  style={{ position: "relative" }}
                >
                  <svg
                    style={{
                      position: "absolute",
                      height: "5rem",
                      top: "-1rem",
                    }}
                    width="150"
                    height="84"
                    viewBox="0 0 150 84"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g opacity="0.5">
                      <path
                        d="M142.298 42.7092C142.298 46.3106 140.506 49.79 137.163 53.0054C133.819 56.2222 128.954 59.1422 122.9 61.6049C110.796 66.5295 94.0394 69.5868 75.5051 69.5868C56.9708 69.5868 40.2144 66.5295 28.1101 61.6049C22.0566 59.1422 17.191 56.2222 13.8468 53.0054C10.5039 49.79 8.71191 46.3106 8.71191 42.7092C8.71191 39.1077 10.5039 35.6284 13.8468 32.4129C17.191 29.1961 22.0566 26.2762 28.1101 23.8134C40.2144 18.8889 56.9708 15.8315 75.5051 15.8315C94.0394 15.8315 110.796 18.8889 122.9 23.8134C128.954 26.2762 133.819 29.1961 137.163 32.4129C140.506 35.6284 142.298 39.1077 142.298 42.7092Z"
                        stroke="#EB942F"
                      />
                      <path
                        d="M148.43 61.4098C148.294 64.2586 146.253 66.5731 142.431 68.2455C138.624 69.9114 133.151 70.8912 126.391 71.1495C112.876 71.6659 94.3239 69.2955 73.9441 63.9036C53.5643 58.5116 35.2521 51.1286 22.1239 43.5631C15.5567 39.7786 10.3138 35.9638 6.75936 32.3503C3.19105 28.7226 1.41974 25.3995 1.55604 22.5507C1.69235 19.7018 3.7334 17.3873 7.55529 15.7149C11.3623 14.0491 16.8346 13.0693 23.5953 12.811C37.1101 12.2946 55.6621 14.6649 76.0419 20.0569C96.4217 25.4489 114.734 32.8319 127.862 40.3973C134.429 44.1818 139.672 47.9966 143.227 51.6102C146.795 55.2378 148.566 58.561 148.43 61.4098Z"
                        stroke="#EB942F"
                      />
                    </g>
                  </svg>
                  Friends
                </div>{" "}
                to view Your Shopping List
              </div>
              <p
                className=""
                style={{
                  fontFamily: "Open Sans",
                  fontWeight: 400,
                  fontSize: "0.9rem",
                  color: "#4D4D4D",
                }}
              >
                Let your friends browse your picks and help you decide what to
                buy next.
              </p>
            </div>
            <div
              className="h-50"
              style={{
                backgroundColor: "#EB942F",
                width: "100%",
              }}
            >
              <div
                className="h-100 d-flex justify-content-center align-items-center"
                style={{
                  position: "relative",
                }}
              >
                <div style={{ padding: "1rem" }}>
                  <img
                    src={inviteFriend}
                    alt=""
                    style={{
                      height: "15rem",
                      padding: "8px", // Gap between image and border
                      border: "3px solid white",
                      borderRadius: "3rem", // Rounded corners
                      boxSizing: "border-box",
                      objectFit: "cover",
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </>
      ) : (
        <div
          style={{
            ...sectionStyle,
            // backgroundColor: "#FFF8F0",
            background:
              "linear-gradient(to right, #FFF8F0 0%, #FFF8F0 48%, #EB942F 48%, #EB942F 100%)",
          }}
          // className={`d-flex align-items-center `}
        >
          <div className=" d-flex align-items-center w-100 h-100 container">
            <div
              style={{
                width: "39%",
              }}
            >
              <div
                // style={{ padding: `0rem 5rem 0rem 16.5rem` }}
                className="d-flex flex-column justify-content-center"
              >
                <div
                  style={{
                    color: "black",
                    fontSize: "3rem",
                    lineHeight: "3.5rem",
                    fontFamily: "Playfair Display",
                    fontWeight: 500,
                  }}
                >
                  Invite your{" "}
                  <div
                    style={{ position: "relative" }}
                    className="d-inline-flex justify-content-center"
                  >
                    <svg
                      style={{
                        position: "absolute",
                        height: "11rem",
                        top: "-4rem",
                      }}
                      width="331"
                      height="210"
                      viewBox="0 0 331 210"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g opacity="0.5">
                        <path
                          d="M300.95 79.4658C302.249 86.0418 299.833 93.0935 294.213 100.247C288.594 107.399 279.811 114.597 268.507 121.428C245.902 135.088 213.31 147.22 176.09 154.567C138.87 161.914 104.112 163.076 78.0127 159.031C64.9607 157.007 54.1017 153.686 46.1866 149.205C38.2696 144.724 33.3559 139.119 32.0578 132.543C30.7598 125.967 33.1752 118.915 38.7955 111.762C44.4145 104.61 53.1969 97.4114 64.5012 90.5804C87.1061 76.9207 119.698 64.7884 156.918 57.4415C194.138 50.0946 228.896 48.9325 254.996 52.9784C268.048 55.0016 278.907 58.323 286.822 62.8034C294.739 67.2848 299.652 72.8897 300.95 79.4658Z"
                          stroke="#E87C00"
                        />
                        <path
                          d="M319.867 110.665C320.627 116.001 317.228 121.058 310.1 125.603C302.996 130.132 292.311 134.07 278.818 137.215C251.838 143.504 213.744 146.601 170.933 145.005C128.122 143.41 88.7345 137.424 59.6678 129.046C45.1306 124.856 33.2042 120.075 24.7279 114.965C16.2231 109.837 11.3408 104.472 10.5813 99.1355C9.82172 93.7996 13.2204 88.7425 20.3484 84.1976C27.4526 79.668 38.1381 75.7306 51.6311 72.5854C78.6101 66.2965 116.704 63.199 159.516 64.7948C202.327 66.3907 241.714 72.3765 270.781 80.7545C285.318 84.9447 297.244 89.725 305.721 94.8354C314.226 99.9629 319.108 105.329 319.867 110.665Z"
                          stroke="#E87C00"
                        />
                      </g>
                    </svg>
                    Friends
                  </div>{" "}
                  to view Your Shopping List
                </div>
                <p
                  className=" mt-4"
                  style={{
                    paddingRight: "3.5rem",
                    fontFamily: "Open Sans",
                    fontWeight: 400,
                    fontSize: "1.4rem",
                    color: "#4D4D4D",
                  }}
                >
                  Let your friends browse your picks and help you decide what to
                  buy next.
                </p>
              </div>
            </div>
            <div
              className="h-100"
              style={{
                position: "absolute",
                right: "0",
                width: "51.5%",
              }}
            >
              <div className="h-100 d-flex justify-content-center align-items-center">
                <div>
                  <img
                    src={inviteFriend}
                    alt=""
                    style={{
                      width: "36rem",
                      height: "24.5rem",
                      objectFit: "cover",
                      padding: "8px", // Gap between image and border
                      border: "3px solid white",
                      borderRadius: "2rem", // Rounded corners
                      boxSizing: "border-box",
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Sign up to get Inspired */}
      <div style={sectionStyle}>
        <Signup_Landing isSmallScreen={isSmallScreen} />
      </div>

      <div
        className="d-flex justify-content-center align-items-center gap-3"
        style={{
          height: "5vh",
          width: "100%",
          scrollSnapAlign: "center",
          position: "relative",
          overflow: "hidden",
          backgroundColor: "#016B6C",
          fontSize: isSmallScreen ? "0.8rem" : "1rem",
        }}
      >
        <Link
          target="_blank"
          style={{ color: "white" }}
          to="/staticPages/termsAndConditions"
        >
          Terms of Service
        </Link>
        <svg
          width="5"
          height="6"
          viewBox="0 0 5 6"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="2.5" cy="3" r="2.5" fill="white" />
        </svg>
        <Link
          target="_blank"
          style={{ color: "white" }}
          to="/staticPages/privacyPolicy"
        >
          Privacy Policy
        </Link>
        <svg
          width="5"
          height="6"
          viewBox="0 0 5 6"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="2.5" cy="3" r="2.5" fill="white" />
        </svg>
        <Link
          target="_blank"
          style={{ color: "white" }}
          to="/staticPages/contactUs"
        >
          Contact Us
        </Link>
      </div>
    </div>
  );
};

export default Landing;
